export let Status;

(function (Status) {
  Status["Synced"] = "synced";
  Status["SyncFailed"] = "syncFailed";
  Status["PendingSync"] = "pendingSync";
  Status["SyncInProgress"] = "syncInProgress";
})(Status || (Status = {}));